
function f(options, rows, data, pageData) {
    console.log('options', options, rows, data, pageData);
    function sumFiled(listData, filed) {
        let res = 0;
        listData.forEach(item => { res = res + Number(item[filed] || 0) * 10000; });
        res = res / 10000;
        if (filed == 'quantity') {
            return res;
        } else {
            if (options.littlePoint == undefined || isNaN(options.littlePoint)) {
                console.log('options.littlePoint', options.littlePoint, res.toFixed(Number(options.littlePoint)));
                return res.toFixed(2);
            }else if (Number(options.littlePoint) == -1) {
                return res;
            }
            else {
                console.log('options.littlePoint', options.littlePoint, res.toFixed(Number(options.littlePoint)));
                return res.toFixed(Number(options.littlePoint));
            }
        }

    }
    const littleQuantity = sumFiled(pageData, 'quantity'); const totalQuantity = sumFiled(rows, 'quantity');
    const littlePrice = sumFiled(pageData, 'total'); const total = sumFiled(rows, 'total');
    const totalBig = hinnn.toUpperCase('7', Number(total));
    let tr = `<tr style='height:${options.tableBodyRowHeight || 18}pt;'>`, littleTr = `<tr style='height:${options.tableBodyRowHeight || 18}pt;'>`, xiaopiaoTr = `<tr style='border:0;height:${options.tableBodyRowHeight || 18}pt;'>`, littleTitleTd = '', titleTd = '', littleQuantityTd = '', totalQuantityTd = '', littlePriceTd = '', totalTd = '', noneTd1 = '', noneTd2 = '';
    let index1 = 0, index2 = 0, columnsLength = options.columns[0].columns.length;
    options.columns[0].columns.forEach((item, index) => {

        if ((item.columnId == 'quantity' && options.tableComputeNumberState) || item.columnId == 'total') {
            let align = item.align || options.textAlign;
            if (index == 0) {
                littleTitleTd = `<td colspan='1' style='text-align: left;' >小计</td>`;
                littleTr += littleTitleTd;
                if (options.computeUpState) {
                    titleTd = `<td colspan='1'  style='text-align: left;'>合计: ${totalBig}</td>`;
                    tr += titleTd;
                } else {
                    titleTd = `<td colspan='1'  style='text-align: left;'>合计: ${total}</td>`;
                    tr += titleTd;
                }
                xiaopiaoTr += `<td colspan='1' style='border:0;border-top: 1px dashed #000;text-align: left;'  >合计</td>`;
                index1 = 0;
            } else {
                if (littleTitleTd == '') {
                    littleTitleTd = `<td colspan='${index}'  style='text-align: left;' >小计</td>`;
                    littleTr += littleTitleTd;
                    if (options.computeUpState) {
                        titleTd = `<td colspan='${index}'  style='text-align: left;'>合计: ${totalBig}</td>`;
                        tr += titleTd;
                    } else {
                        titleTd = `<td colspan='${index}'  style='text-align: left;'>合计: ￥${total}</td>`;
                        tr += titleTd;
                    }
                    xiaopiaoTr += `<td colspan='${index}' style='border:0;border-top: 1px dashed #000;text-align: left;'>合计</td>`;
                    if (item.columnId == 'quantity') {
                        littleQuantityTd = `<td colspan='1' style='text-align: ${align};' >${littleQuantity}</td>`;
                        totalQuantityTd = `<td colspan='1'  style='text-align: ${align};' >${totalQuantity}</td>`;
                        littleTr += littleQuantityTd;
                        tr += totalQuantityTd;
                        xiaopiaoTr += `<td colspan='1'  style='border:0;border-top: 1px dashed #000;text-align: ${align};' >${totalQuantity}</td>`;
                    } else {
                        littlePriceTd = `<td colspan='1'  style='text-align: ${align};' >${littlePrice}</td>`;
                        totalTd = `<td colspan='1'  style='text-align: ${align};' >${total}</td>`;
                        littleTr += littlePriceTd;
                        tr += totalTd;
                        xiaopiaoTr += `<td colspan='1'  style='border:0;border-top: 1px dashed #000;text-align: ${align};' >${total}</td>`;
                    }
                    index1 = index;

                } else {
                    index2 = index;
                    if (index2 - index1 - 1 > 0) {
                        noneTd1 = `<td colspan='${index2 - index1 - 1}' ></td>`;
                        littleTr += noneTd1;
                        tr += noneTd1;
                        xiaopiaoTr += `<td colspan='${index2 - index1 - 1}'  style='border:0;border-top: 1px dashed #000;' ></td>`;
                    }
                    if (item.columnId == 'quantity') {
                        littleQuantityTd = `<td colspan='1'  style='text-align: ${align};' >${littleQuantity}</td>`;
                        totalQuantityTd = `<td colspan='1'  style='text-align: ${align};' >${totalQuantity}</td>`;
                        littleTr += littleQuantityTd;
                        tr += totalQuantityTd;
                        xiaopiaoTr += `<td colspan='1'  style='border:0;border-top: 1px dashed #000;text-align: ${align};' >${totalQuantity}</td>`;
                    } else {
                        littlePriceTd = `<td colspan='1'  style='text-align: ${align};' >${littlePrice}</td>`;
                        totalTd = `<td colspan='1'  style='text-align: ${align};' >${total}</td>`;
                        littleTr += littlePriceTd;
                        tr += totalTd;
                        xiaopiaoTr += `<td colspan='1'  style='border:0;border-top: 1px dashed #000;text-align: ${align};' >${total}</td>`;
                    }
                }
            }
        }
    })
    console.log('index1', index1, index2, columnsLength - index1 - 1, littleTr)
    if (index1 == 0 && index2 == 0) {
        // tr += `<td colspan='${columnsLength - 1}'  ></td></tr>`;
        // littleTr += `<td colspan='${columnsLength - 1}' ></td></tr>`;
        // xiaopiaoTr += `<td colspan='${columnsLength - 1}'  style='border:0;border-top: 1px dashed #000;;'  ></td></tr>`;
        //<tr style='border:0;'>


        littleTitleTd = `<td colspan='${columnsLength}' style='text-align: left;' >小计</td>`;
        littleTr = `<tr style='height:${options.tableBodyRowHeight || 18}pt;'>${littleTitleTd} </tr>`;
        if (options.computeUpState) {
            titleTd = `<td colspan='${columnsLength}'  style='text-align: left;'>合计: ${totalBig}</td>`;
            tr = `<tr style='height:${options.tableBodyRowHeight || 18}pt;'>${titleTd} </tr>`;
        } else {
            titleTd = `<td colspan='${columnsLength}'  style='text-align: left;'>合计: ${total}</td>`;
            tr = `<tr style='height:${options.tableBodyRowHeight || 18}pt;'>${titleTd} </tr>`;
        }
        xiaopiaoTr = `<tr style='border:0;height:${options.tableBodyRowHeight || 18}pt;'><td colspan='${columnsLength}' style='border:0;border-top: 1px dashed #000;text-align: left;'  >合计</td>`;
    } else if (index2 == 0) {
        if (columnsLength - index1 - 1 > 0) {
            tr += `<td colspan='${columnsLength - index1 - 1}' ></td></tr>`;
            littleTr += `<td colspan='${columnsLength - index1 - 1}' ></td></tr>`;
            xiaopiaoTr += `<td colspan='${columnsLength - index1 - 1}'  style='border:0;border-top: 1px dashed #000;'  ></td></tr>`;
        } else {
            tr += `</tr>`;
            littleTr += `</tr>`;
            xiaopiaoTr += `</tr>`;
        }
    } else {
        if (columnsLength - index2 - 1 > 0) {
            tr += `<td colspan='${columnsLength - index2 - 1}' ></td></tr>`;
            littleTr += `<td colspan='${columnsLength - index2 - 1}' ></td></tr>`;
            xiaopiaoTr += `<td colspan='${columnsLength - index2 - 1}'  style='border:0;border-top: 1px dashed #000;'  ></td></tr>`;
        }
    }

    if (options.tableStyle == 'style2') {
        return xiaopiaoTr;
    }
    if (JSON.stringify(pageData[pageData.length - 1]) == JSON.stringify(rows[rows.length - 1])) {
        if (options.tableCompute1 && options.tableCompute2) {
            return littleTr + tr;
        } else if (options.tableCompute1) {
            return littleTr;
        } else if (options.tableCompute2) {
            return tr;
        } else {
            return ``;
        }
    }
    else {
        if (options.tableCompute1) {
            return littleTr;
        } else {
            return ``;
        }

    }
}
export default f.toString()